export const yourContactInformationStrings = {
  strings: {
    en: {
      yourContactInformation: 'Your Contact Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email Address (Optional)',
      phone: 'Telephone Number (Optional)',
      hearingImpaired: 'Hearing Impaired / Use TTY (English Only)',
      sourceCodeDescription: 'If you are an agency, please enter your source code',
      sourceCode: 'Source Code (AGENCY ONLY)',
      firstNameErrorMsg: 'Please enter your first name',
      lastNameErrorMsg: 'Please enter your last name',
      confirmationEmail: 'Confirmation Email',
      confirmationEmailDescription: 'Enter your email to help us track your request.',
      'Please enter your first name.': 'Please enter your first name.',
      'Please enter your last name.': 'Please enter your last name.',
      'Please enter your valid email.': 'Please enter your valid email.',
      landLine : 'Landline',
      mobile : 'Mobile',
    },
    zh: {
      yourContactInformation: '您的聯繫信息',
      firstName: '名字',
      lastName: '姓',
      email: '電子郵件地址（可選）',
      phone: '電話號碼（可選）',
      hearingImpaired: '聽障人士/使用TTY（僅限英文）',
      sourceCodeDescription: '如果您是代理商，請輸入您的源代碼',
      sourceCode: '源代碼（僅限代理商）',
      firstNameErrorMsg: '請輸入您的名字',
      lastNameErrorMsg: '請輸入您的姓氏',
      confirmationEmail: '確認郵件',
      confirmationEmailDescription: '如果您想收到退出確認，請輸入您的電子郵件地址。',
      'Please enter your valid email.': '请输入您的有效电子邮件。',


    },
    es: {
      yourContactInformation: 'Tu información de contacto',
      firstName: 'Nombre de pila',
      lastName: 'Apellido',
      email: 'Dirección de correo electrónico (opcional)',
      phone: 'Número de teléfono (opcional)',
      hearingImpaired: 'Personas con problemas de audición / Usar TTY (sólo en inglés)',
      sourceCodeDescription: 'Si respondes en nombre de una agencia, ingresa tu código fuente.',
      sourceCode: 'Código fuente (AGENCIA SOLAMENTE)',
      firstNameErrorMsg: 'Please enter your first name',
      lastNameErrorMsg: 'Please enter your last name',
      confirmationEmail: 'Correo electrónico de confirmación',
      confirmationEmailDescription: 'Ingrese su correo electrónico para ayudarnos a rastrear su solicitud.',
      'Please enter your first name.': 'Por favor ingrese su nombre',
      'Please enter your last name.': 'Por favor ingrese su apellido.',
      'Please enter your valid email.': 'Por favor ingrese su correo electrónico válido.',
    },
    ko: {
      yourContactInformation: '귀하의 연락처 정보',
      firstName: '이름',
      lastName: '성',
      email: '전자 메일 주소 (선택 사항)',
      phone: '전화 번호 (선택 사항)',
      hearingImpaired: '청각 장애자 / TTY 사용 (영어로만 제공)',
      sourceCodeDescription: '귀하와 대행사 인 경우 소스 코드를 입력하십시오.',
      sourceCode: '소스 코드 (에이전시 만 해당)',
      firstNameErrorMsg: 'Please enter your first name',
      lastNameErrorMsg: 'Please enter your last name',
      confirmationEmail: '확인 이메일',
      confirmationEmailDescription: '등록 취소 확인을 받기 원하시면, 고객님의 이메일 주소를 입력하세요.',
      'Please enter your valid email.': '유효한 이메일을 입력하십시오.',
    },
    vi: {
      yourContactInformation: 'thông tin liên lạc của bạn',
      firstName: 'Tên đầu tiên',
      lastName: 'Họ',
      email: 'Địa chỉ Email (Tùy chọn)',
      phone: 'Số điện thoại (Tùy chọn)',
      hearingImpaired: 'Khiếm thính / Sử dụng TTY (chỉ tiếng Anh)',
      sourceCodeDescription: 'Nếu bạn là và đại lý, vui lòng nhập mã nguồn của bạn',
      sourceCode: 'Mã nguồn (CHỈ CƠ QUAN)',
      firstNameErrorMsg: 'Please enter your first name',
      lastNameErrorMsg: 'Please enter your last name',
      confirmationEmail: 'Email Xác Nhận',
      confirmationEmailDescription: 'Nếu quý vị muốn có xác nhận bỏ ghi danh, xin vui lòng nhập địa chỉ email.',
      'Please enter a valid ZIP code.': 'Vui lòng nhập một mã zip hợp lệ.',
      'Please enter your valid email.': 'Vui lòng nhập email hợp lệ của bạn.',
    }
  },
  common: ['makeSelection']
};